import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../WhatIfsSelector';

export const principalNameSelector = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return whatIfOptions.PrincipalName || '';
};

export const principalAgeOptionsSelector = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return (whatIfOptions.PrincipalRetirementAgeOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};

export const yearsAmountOptionsSelector = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return [...Array(whatIfOptions.MarketDropsMaxNumYears).keys()].map(x => ({
    value: x + 1,
    label: (x + 1).toString(),
  }));
};

export const marketDropsPercentageSelector = (state, props) =>
  whatIfInnerSelector(state, props).MarketDropsPercentage * 100;

export const principalAgeSelector = (state, props) =>
  whatIfInnerSelector(state, props).MarketDropsStartingAge;

export const yearsAmountSelector = (state, props) =>
  whatIfInnerSelector(state, props).MarketDropsNumYears;
